const TIPOS_DISTRIBUIDOR = [
  {
    id: 1,
    name: 'Comercializador'
  },
  {
    id: 2,
    name: 'Comercializador + Soporte'
  },
]

export {
  TIPOS_DISTRIBUIDOR
}
